<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXSBMeasureList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBMeasureForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXSBMeasureForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'

const { mapGetters, mapActions } = createNamespacedHelpers('exsbmeasure/create')

export default {
  components: {
    EXSBMeasureForm
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBMeasureCreate')
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXSBMeasureUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
